import { SetProfilePicture } from '@pypestream/design-system';

/**
 * A FilePond `onUpload` that does NOT upload. It tells FilePond the item is
 * "done" (so the image-preview thumbnail renders) and forwards the raw File to
 * the consumer via `onChange({ files: [file] })`. The real PUT is deferred to
 * the channel Save handler, so Cancel can discard the file with nothing to undo.
 * Shared by the channel logo (PSTUDIO-3078) and Brand Moment (PSTUDIO-3710)
 * uploads — the factory is generic; only the Save-time PUT differs per field.
 */
export const createDeferredFileUpload =
  (): SetProfilePicture =>
  ({ file, load, onChange, abort }) => {
    if (file) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore - FilePond `load` accepts the file name as the server id
      load?.(file.name);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore - deferred: only the raw File is forwarded, no server url/id
      onChange?.({ files: [file] });
    }
    return { abort: () => abort?.() };
  };
